module.exports = __webpack_public_path__ + "img/06.8b6ba94e.png";